import { PharmacyCreateCard } from "./superAdminDashboard/pharmacies/PharmacyCreateCard";
import { PharmacyListCard } from "./superAdminDashboard/pharmacies/PharmacyListCard";
import { usePharmacies, usePharmacyCreation } from "./superAdminDashboard/pharmacies/usePharmacies";
import { usePharmacyEditor } from "./superAdminDashboard/pharmacies/usePharmacyEditor";
import { UsersCard } from "./superAdminDashboard/users/UsersCard";
import { usePharmacyUsers } from "./superAdminDashboard/users/usePharmacyUsers";
import { BdpmImportStatus } from "./superAdminDashboard/BdpmImportStatus";

function DashboardHeader() {
    return (
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: "32px" }}>
            <div>
                <h1 style={{ fontSize: "28px", fontWeight: 700, color: "#111827", margin: 0, marginBottom: "6px" }}>
                    Gestion des pharmacies
                </h1>
                <p style={{ fontSize: "14px", color: "#6b7280", margin: 0 }}>
                    Créez et configurez les pharmacies, leur boîte mail et leurs utilisateurs.
                </p>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px", color: "#7c6fcd", fontSize: "13px", fontWeight: 600, whiteSpace: "nowrap", paddingTop: "4px" }}>
                <span style={{ fontSize: "15px" }}>◇</span>
                Espace Super Admin
            </div>
        </div>
    );
}

export default function SuperAdminDashboard() {
    const { pharmacies, loading, error, handleToggle, addPharmacy, replacePharmacy } = usePharmacies();
    const creation = usePharmacyCreation(addPharmacy);
    const editor = usePharmacyEditor(replacePharmacy);
    const users = usePharmacyUsers();

    return (
        <div style={{ minHeight: "100%", background: "#f4f6f9", boxSizing: "border-box" }}>
            <div style={{ maxWidth: "960px", margin: "0 auto", padding: "40px 32px" }}>
                <DashboardHeader />
                <BdpmImportStatus />
                <PharmacyCreateCard
                    form={creation.form}
                    setForm={creation.setForm}
                    submitting={creation.submitting}
                    formError={creation.formError}
                    onSubmit={creation.handleSubmit}
                />
                <PharmacyListCard
                    pharmacies={pharmacies}
                    loading={loading}
                    error={error}
                    onToggle={handleToggle}
                    editor={editor}
                />
                <UsersCard pharmacies={pharmacies} users={users} />
            </div>
        </div>
    );
}
